
import miniToastr from 'mini-toastr'
import HttpStatus from 'http-status-codes'
import lodash from 'lodash'
import i18n from '@/utils/i18n'
import { NotifyType } from '@/utils/consts'

miniToastr.init()

const errorMsgDuration = 300000

const notification = {
  handleResponseAlert (response, optPrefix = '', fallbackOpt = '', showNotification = true) {
    if (response) {
      const name = lodash.get(response, 'data.name') || ''
      const isV2Err = i18n.te(`error.${name}`)
      const prefix = isV2Err ? name : optPrefix
      const fallbackErrPrefix = fallbackOpt || 'error'
      const status = response.status

      let errorMsg
      if (status) {
        const errorPrefix = prefix ? `error.${prefix}` : 'error'
        if (status === HttpStatus.SERVICE_UNAVAILABLE) {
          errorMsg = getErrorMessage(`${errorPrefix}.503`, `${fallbackErrPrefix}.503`)
        } else if (status === HttpStatus.INTERNAL_SERVER_ERROR) {
          errorMsg = getErrorMessage(`${errorPrefix}.500`, `${fallbackErrPrefix}.500`)
        } else if (status === HttpStatus.CONFLICT) {
          errorMsg = getErrorMessage(`${errorPrefix}.409`, `${fallbackErrPrefix}.409`)
        } else if (status === HttpStatus.FORBIDDEN) {
          errorMsg = getErrorMessage(`${errorPrefix}.403`, `${fallbackErrPrefix}.403`)
        } else if (status === HttpStatus.BAD_REQUEST) {
          errorMsg = getErrorMessage(`${errorPrefix}.400`, `${fallbackErrPrefix}.400`)
        } else if (status === HttpStatus.NOT_FOUND) {
          errorMsg = getErrorMessage(`${errorPrefix}.404`, `${fallbackErrPrefix}.404`)
        } else if (status === HttpStatus.REQUEST_TIMEOUT) {
          errorMsg = getErrorMessage(`${errorPrefix}.408`, `${fallbackErrPrefix}.408`)
        } else if (status === HttpStatus.GONE) {
          errorMsg = getErrorMessage(`${errorPrefix}.410`, `${fallbackErrPrefix}.410`)
        } else if (status === HttpStatus.FAILED_DEPENDENCY) {
          errorMsg = getErrorMessage(`${errorPrefix}.424`, `${fallbackErrPrefix}.424`)
        } else if (status === HttpStatus.PRECONDITION_REQUIRED) {
          errorMsg = getErrorMessage(`${errorPrefix}.428`, `${fallbackErrPrefix}.428`)
        } else if (status === HttpStatus.LOCKED) {
          errorMsg = getErrorMessage(`${errorPrefix}.423`, `${fallbackErrPrefix}.423`)
        } else if (status === HttpStatus.OK ||
          status === HttpStatus.CREATED ||
          status === HttpStatus.NO_CONTENT) {
          uniqueNotify(NotifyType.INFO, i18n.t('success'))
        } else {
          if ((HttpStatus.BAD_REQUEST < status) && (status < HttpStatus.INTERNAL_SERVER_ERROR)) {
            errorMsg = getErrorMessage(`${errorPrefix}.client`, `${fallbackErrPrefix}.client`)
          } else {
            errorMsg = getErrorMessage(`${errorPrefix}.system`)
          }
        }
        if (showNotification && errorMsg) {
          notifyError(errorMsg)
        }
      }
      return errorMsg
    }
  },
  handleResponseError (error, optPrefix) {
    if (error.code === 'ECONNABORTED') {
      notification.fireNotification(false, i18n.t('error.408'))
      return
    }
    if (error.response) {
      this.handleResponseAlert(error.response, optPrefix)
    } else {
      if (optPrefix) {
        console.log(`Encountered error when ${optPrefix}:`)
      }
      console.error(error)
    }
  },
  fireNotification (isInfo, message) {
    if (isInfo) {
      miniToastr.info(message)
    } else {
      notifyError(message)
    }
  },
  warn (message) {
    uniqueNotify(NotifyType.WARN, message)
  },
  error (message) {
    notifyError(message)
  },
  clearAll () {
    $('.mini-toastr').empty()
  },
  handleServerErrorMessage (err, optPrefix) {
    const resMessage = lodash.get(err, 'response.data.message', null)
    const shouldNotifyErr = lodash.get(err, 'response.data.shouldNotifyErr', false)
    if (shouldNotifyErr && resMessage) {
      const errMsg = Array.isArray(resMessage) ? resMessage : [resMessage]
      errMsg.forEach(msg => {
        this.fireNotification(false, msg)
      })
    } else {
      this.handleResponseError(err, optPrefix)
    }
  },
}

function notifyError (message) {
  uniqueNotify(NotifyType.ERROR, message)
}

function uniqueNotify (level, message) {
  const notifyElem = $(`.mini-toastr .mini-toastr__notification.-${level} .mini-toastr-notification__message`)
  let isDuplicateMessage = false
  notifyElem.each(function () {
    if ($(this)[0].textContent === message) {
      isDuplicateMessage = true
    }
  })
  if (!isDuplicateMessage) {
    miniToastr[level](message, null, level !== NotifyType.INFO ? errorMsgDuration : null)
  }
}

function getErrorMessage (msgKey, fallbackMsgKey) {
  let validMsgKey = msgKey
  if (!i18n.te(msgKey)) {
    validMsgKey = fallbackMsgKey
    if (!i18n.te(fallbackMsgKey)) {
      validMsgKey = 'error.system'
    }
  }
  return i18n.t(validMsgKey)
}

export default notification
